// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入element-ui
// import ElementUI from 'element-ui'
import { DatePicker, Popover } from 'element-ui'
import VueLazyload from 'vue-lazyload'

import 'img-previewer/dist/index.css'

Vue.use(DatePicker)
Vue.use(Popover)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/error.jpeg'),
  loading: require('./assets/loading.jpg')
})
Vue.config.productionTip = false

/* eslint-disable no-new */
// 引入element-ui
// Vue.use(ElementUI)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js